import { IGiftGroupGift } from "@interfaces/consumer/daily";
import { FC } from "react";
import { Link } from "react-router";
import { ColumnDef } from "@tanstack/react-table";
import { Flex } from "@components/falcon/common";
import { Card } from "react-bootstrap";
import { AdvanceTable } from "@components/falcon/common/tables";
import AdvanceTableProvider from "@components/falcon/common/tables/context";
import { useTable } from "@hooks/tableHooks";

const columns: ColumnDef<IGiftGroupGift>[] = [
    {
        accessorKey: 'name',
        header: 'Название',
        enableSorting: false,
        meta: {
            headerProps: { className: 'pe-1 text-900' },
            cellProps: { className: 'py-2' }
        },
        cell: ({row: {original: {id, name}}}) => (
            <Link to={`/consumer/daily/${id}/`}>
                <Flex alignItems="center">
                    <div className="flex-1">
                        <h5 className="mb-0 fs-10">{name}</h5>
                    </div>
                </Flex>
            </Link>
        )
    }
]

interface GiftGroupGiftsBlockProps {
    gifts: IGiftGroupGift[];
}

const GiftGroupGiftsBlock: FC<GiftGroupGiftsBlockProps> = ({gifts}) => {

    const table = useTable({
        columns,
    }, gifts);

    return (
        <AdvanceTableProvider table={table}>
            <Card className="mb-3">
                <Card.Header as="h6" className="bg-body-tertiary">
                    Подарки в группе
                </Card.Header>
                <Card.Body className="p-0">
                    <AdvanceTable
                        headerClassName="bg-200 text-nowrap align-middle"
                        rowClassName="align-middle white-space-nowrap"
                        emptyText="В группе нет подарков"
                        tableProps={{
                            size: 'sm',
                            striped: true,
                            className: 'fs-10 mb-0 overflow-hidden'
                        }}
                    />
                </Card.Body>
            </Card>
        </AdvanceTableProvider>
    )
}

export default GiftGroupGiftsBlock;
